import React from "react";
import {Button, Modal} from "react-bootstrap";
import {QrReviewExplanation} from "./QrReviewExplanation";

// "Why is this a draft?" popup for a Draft Purchases row.
export function QrDraftWhyDialog({row, onClose, onEdit}) {
    return (
        <Modal show={!!row} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Why this purchase is a draft</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {row && (
                    <>
                        <div className="text-muted fs-7 mb-4">
                            Vehicle <span className="fw-semibold text-gray-800">{row.vehicleNumber || "-"}</span>
                        </div>
                        <QrReviewExplanation reasons={row.reviewReasons} note={row.reviewNote}/>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={onClose}>Close</Button>
                {row && onEdit && (
                    <Button variant="primary" onClick={() => { const r = row; onClose(); onEdit(r); }}>Edit</Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}
